<template>
  <div>
    {{/** top header */}}
    <div class="t-header" id="main-header-top">
      <div class="inner-content">
        <div class="com-qr-1 pull-left text-center">
          <a class="link-text m-r" href="#"><i class="fa fa-wechat" /> 微信公众号</a>
          <img src="./assets/bride_wechat_qrcode.jpg">
          <div class="com-qr-desc">
            微信公众号
          </div>
        </div>
        <a class="link-text m-r" href="http://weibo.com/cosmobride" target="_blank"><i class="fa fa-weibo" /> 新浪微博</a>
        <div class="pull-right">
          <a class="link-text m-r" href="#/login" v-if="!isLogin">登录</a>
          <a class="link-text m-r" href="#/register" v-if="!isLogin">注册</a>
          <!--<a class="link-text m-r" href="#/collect" v-if="isLogin">我的收藏</a>-->
          <a class="link-text m-r telephone" v-if="isLogin" @click="showPanel()">{{telephone}}</a>
          <a class="fa fa-angle-down" style="margin-right: 23px" v-if="isLogin" @click="showPanel()"></a>
          <div class="panel text-center" v-if="isShowPanel">
            <a class="gray-4" href="#/collect" @click="showPanel()">我的收藏</a><br/>
            <a class="gray-4" href="#/order/list/" @click="showPanel()">我的订单</a><br/>
            <a class="gray-4" href="#/forgetpass" @click="showPanel()">忘记密码</a><br/>
            <a class="gray-4" href="#" @click="logout()">退出登录</a>
          </div>
          <!--<a class="link-text m-r" href="#" v-if="isLogin" @click="logout()">登出</a>-->
          <a class="link-text" target="_blank" href="/admin/#/">进入商家中心</a>
        </div>
      </div>
    </div>
    {{/** search header */}}
    <div class="inner-content search-header m-t-md" v-if="hasHeader()">
      <img src="https://cosmolove.oss-cn-beijing.aliyuncs.com/bride/logo_0.png" class="header-img pull-left" style="width: 12%;" @click="goHome"  />
      <div class="pull-right text-right">
        <div class="gray-1">时尚新娘客服热线</div>
        <div class="phone-number">400-900-8520</div>
      </div>
      <div class="search-wrp">
        <input class="search-box" style="::-ms-clear" placeholder="搜索商家、套餐、案例" v-model="keyword" v-on:keyup.enter="searchKey">
        <i class="fa fa-remove search-remove" @click="removeKey" v-if="keyword!==''"/>
        <i class="fa fa-search search-icon" @click="searchKey" />
      </div>
      <div class="search-wrp gray-2 search-hint">
        <span>热门搜索：</span>
        <span style="margin-left: 1rem" role="button" v-for="(item, n) in hotWords" @click="clickHotWord(item)">{{item.name}}</span>
      </div>
    </div>
    {{/** content header */}}
    <div v-sticky="{ zIndex: 12, stickyTop: 0 }" v-if="isHomePage()">
      <div class="bg-white">
        <div class="inner-content p-t-md clearfix">
          <div class="pull-right more-link" @click="toList">更多 <i class="fa fa-angle-right" /></div>
          <!--<div>-->
            <!--<div style="float: left; width: 100px; height: 100px;"><div>a</div><div style="background-color: #ba882a">line</div></div>-->
            <!--<div style="float: left; width: 100px; height: 100px;">b</div>-->
          <!--</div>-->
          <div>
            <div class="categ-div" style="float: left; ">
              <div class="categ" role="button" @click="scrollTo('home-top-area', 0)">首页</div>
              <div class="categ-line" v-if="activeDetailTag==0"></div>
            </div>
            <div class="categ-div" style="float: left; ">
              <div class="categ" role="button" @click="scrollTo('home-recmd-area', 1)">特别推荐</div>
              <div class="categ-line" v-if="activeDetailTag==1"></div>
            </div>
            <div class="categ-div" style="float: left; ">
              <div class="categ" role="button" @click="scrollTo('home-video-area', 2)">致爱影像</div>
              <div class="categ-line" v-if="activeDetailTag==2"></div>
            </div>
            <div class="categ-div" style="float: left; " v-for="(item,n) in categArr">
              <div class="categ" role="button" @click="scrollTo(`home-categ-area-${n}`, 3+n)">{{item}}</div>
              <div class="categ-line" v-if="activeDetailTag==3+n"></div>
            </div>
            <div class="categ-div" style="float: left; ">
              <div class="categ" role="button" @click="scrollTo('home-info-area',3+categArr.length)">资讯</div>
              <div class="categ-line" v-if="activeDetailTag==3+categArr.length"></div>
            </div>
          </div>
        </div>
        <!--<hr class="home-hr"/>-->
      </div>
    </div>
    <hr class="home-hr m-t-md" v-if="!isHomePage() && hasHeader() && !isPayPage()" />
    {{/** content */}}
    <router-view></router-view>
    {{/** footer */}}
    <div class="login-footer login-footer-tp" v-if="hasFooter()">
      <div>
        <h4>时尚新娘客服热线</h4>
        <div>工作时间：每日09:00-23:00</div>
        <div class="phone-number">400-900-8520</div>
      </div>
      <div>
        <h4>下载手机app</h4>
        <div><img class="footer-qr" src="./assets/bride_app_qrcode.png" /></div>
        <div style="margin-top:5px;text-align:center"><a href="http://api.ccbride.com:8080/rest/openIosApp.html" style="color:white;">立即下载</a></div>
      </div>
      <div>
        <h4>关于我们</h4>
        <div class="m-b-ft"><a class="gray-4" target="_blank" href="#/aboutus/">关于时尚</a></div>
      </div>
      <div>
        <h4>联系我们</h4>
        <div class="m-b-ft">手机：186-1105-2766</div>
        <div class="m-b-ft">电话：010-6589-5819</div>
        <div class="m-b-ft">邮箱：wangxin@cosmo.love</div>
        <div>地点：北京市朝阳区光华路9号时尚大厦</div>
      </div>
    </div>
    <div class="login-footer login-footer-bt">
      <a target="_blank" href="http://www.miitbeian.gov.cn/" style="text-decoration:none;color: #787878;">京ICP备17048592号</a>
      <a target="_blank" href="http://www.beian.gov.cn/" style="text-decoration:none;color: #787878;margin-left: 20px;"><img src="https://cosmolove.oss-cn-beijing.aliyuncs.com/bride/national_emblem_icon.jpg" style="display: inline-block;vertical-align: -3px;margin-right: 5px;"/>京公网安备 11010502040704号</a>
      <br/>
      时尚致爱(北京)文化有限公司 © 2018 Copyright.
    </div>
    <div class="fixed-com" v-if="hasCom" style="z-index: 13">
      <div class="com-wrp clearfix" >
        <div class="com-header com-hide">在线咨询
          {{/** close button */}}
          <i class="pull-right fa fa-times close-icon hidden"></i>
        </div>
        <div class="com-item qq-wrp clearfix" style="background-color: #e5e5e5;">
          <i class="fa fa-qq icon-fa" /> <div class="com-content com-hide"><a href="tencent://message/?uin=4086724637&Site=&Menu=yes">4086724637</a></div>
        </div>
        <div class="com-item com-item-3 com-hide">
          <i class="fa fa-phone icon-fa" />
          <div class="com-content">联系电话 <br> 400-900-8520</div>
        </div>
      </div>
      <div class="clearfix">
        <div class="com-qr pull-right com-item-3 text-center">
          <img src="./assets/bride_app_qrcode.png">
          <div class="com-qr-desc">
            扫码下载app
          </div>
        </div>
      </div>
      <div class="clearfix">
        <div class="com-login pull-right com-item-3 text-center" @click="gotoLogin">
          <img src="./assets/bride_app_login.png">
          <div class="com-login-desc">
            登录
          </div>
        </div>
      </div>
      <div class="com-item-3 pull-right text-center com-scroller" @click="scrollToTop">
        <i class="fa fa-angle-up" />
      </div>
    </div>
  </div>
</template>

<script>
import scrollToElement from 'scroll-to-element';
import toastr from 'mini-toastr';
import VueSticky from 'vue-sticky';
import uService from './service/user';
import cmService from './service/common';
import bus from './utils/bus';

export default {
  name: 'app',
  data() {
    return {
      keyword: '',
      hasCom: true,
      username: '',
      telephone: undefined,
      isLogin: false,
      categArr: [],
      activeDetailTag: 0,
      communicateActive: false,
      isShowWechat: false,
      isShowPanel: false,
      hotWords: [],
    };
  },
  methods: {
    toList() {
//      this.$router.push({ name: 'List' });
      window.open('#/list');
    },
    goHome() {
      this.$router.replace({ name: 'Index' });
    },
    isHomePage() {
      return this.$route.name === 'Index';
    },
    isPayPage() {
      return this.$route.name === 'Pay';
    },
    hasHeader() {
      return this.$route.fullPath.indexOf('/login') < 0
        && this.$route.fullPath.indexOf('/register') < 0
        && this.$route.fullPath.indexOf('/forgetpass') < 0
        && this.$route.fullPath.indexOf('/policy') < 0
        && this.$route.fullPath.indexOf('/pay') < 0;
    },
    hasFooter() {
      return this.$route.fullPath.indexOf('/policy') < 0;
    },
    searchKey() {
      this.keyword = this.keyword.replace(/\s+/g, '');
      if (this.keyword.length > 0) {
        this.$router.replace({ name: 'List', query: { keyword: this.keyword } });
      }
      if (this.$route.name === 'List') { // 如果是在list页面 发消息
        this.$router.replace({ query: { keyword: this.keyword } });
        bus.$emit('SEARCH_CHANGED', this.keyword);
      }
    },
    clickHotWord(item) {
      this.keyword = item.name;
      this.searchKey();
    },
    removeKey() {
      this.keyword = '';
      this.$router.replace({ query: { keyword: this.keyword } });
      if (this.$route.name === 'List') { // 如果是在list页面 发消息
        bus.$emit('SEARCH_CHANGED', this.keyword);
      }
    },
    scrollTo(el, index) {
      this.activeDetailTag = index;
      const options = {
        easing: 'linear',
        offset: -60,
      };
      scrollToElement(`#${el}`, options);
    },
    logout() {
      uService.logout();
      this.isShowPanel = false;
//      this.$router.go(0);
    },
    gotoLogin() {
      if (!this.isLogin) {
        this.$router.replace({ name: 'Login' });
      } else {
        toastr.error('您已经登录了');
      }
    },
    scrollToTop() {
      const options = {
        easing: 'linear',
      };
      scrollToElement('#main-header-top', options);
    },
    showWechat() {
      this.isShowWechat = true;
    },
    showPanel() {
      this.isShowPanel = !this.isShowPanel;
    },
  },
  created() {
    toastr.init();
    this.isLogin = uService.hasLogin();
    this.telephone = localStorage.getItem('telephone');
    if (this.isLogin) {
      this.username = uService.getUser().nickname;
    }
    const categStr = this.$cookie.get('categ_arr');
    if (categStr) {
      this.categArr = JSON.parse(categStr);
    }

    cmService.locs().then((resp) => {
      console.log(`hehehe ${resp.hotWords}`);
      this.hotWords = resp.hotWords;
    }, (resp) => {
      console.log(`cmservice error ${resp}`);
    });

    bus.$on('CATEG_CHANGED', (arr) => {
      this.categArr = arr;
      this.$cookie.set('categ_arr', JSON.stringify(this.categArr));
    });
    bus.$on('USER_CHANGED', () => {
      this.isLogin = uService.hasLogin();
      if (this.isLogin) {
        this.username = uService.getUser().nickname;
      } else {
        this.username = '';
      }
    });
  },
  directives: {
    sticky: VueSticky,
  },
};
</script>
<style>
.inner-content {
  max-width: 1200px;
  margin: 0 auto;
}
.t-header {
  font-size: 14px;
  background-color: #333333;
  height: 35px;
  line-height: 35px;
  color: #a9a9a9;
}
.inner-content a.link-text {
  color: #a9a9a9;
}
.header-img {
  height: 100%;
  cursor: pointer;
}
.search-wrp {
  width: 618px;
  margin-left: 195px;
  position: relative;
}
input::-ms-clear {
  display: none;
}
.search-box {
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 25px;
  width: 100%;
  border: 0 none;
  padding: 15px 70px 15px 40px;
  font-size: 14px;
}
.phone-number {
  font-size: 20px;
  color: #df3a4e;
  margin-top: 12px;
}
.search-hint {
  color: #b4b4b4;
  font-size: 12px;
  padding-left: 25px;
  margin-top: 5px;
}
.nav-item {
  margin-right: 60px;
}
.nav-item:hover {
  color: #ba882a;
}
hr {
  display: block;
  /*height: 1px;*/
  border: 0;
  border-top: 1px solid #ccc;
  margin: 0;
  padding: 0;
}
hr.home-hr {
  border-color: #ba882a;
}
.login-footer {
  background-color: #252525;
  text-align: center;
  color: #787878;
}
.login-footer-tp {
  padding-bottom: 64px;
}
.login-footer h4 {
  color: #fff;
  margin: 45px 0 44px;
}
.login-footer > div {
  display: inline-block;
  margin-right: 199px;
  text-align: left;
  vertical-align: top;
}
.login-footer > div:last-child {
  margin-right: 0;
}
.footer-qr {
  height: 104px;
  width: 104px;
}
.m-b-ft {
  margin-bottom: 12px;
}
.login-footer-bt {
  height: 84px;
  line-height: 42px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px dotted #5f5f5f;
}
.more-link {
  color: #999;
  font-size: 12px;
  line-height: 22px;
  cursor: pointer;
}
.fixed-com {
  position: fixed;
  top: 12%;
  right: 0;
  font-size: 14px;
}
.fixed-com div.com-item {
  padding: 15px 0 15px 20px;
  font-weight: 300;
  color: #414141;
}
.fixed-com div.com-header {
  font-weight: 600;
  padding: 20px;
  color: #fff;
  background-color: #444444;
  text-align: center;
}
.com-content {
  margin-left: 20px;
}
.com-content a{
  text-decoration: none;
  color: #414141;
}
.fixed-com i.pull-left {
  margin-top: 2px;
}
.fixed-com .close-icon {
  font-size: 20px;
  cursor: pointer;
}
.com-qr {
  padding: 11px;
  line-height: 0;
}
.com-qr img{
  width: 20px;
  height: 20px;
}
.com-qr:hover {
  padding: 30px;
}
.com-qr:hover img {
  width: 118px;
  height: 118px;
}
.com-item-3 {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-top: 0 none;
}
.com-qr-desc {
  display: none;
}
.com-qr:hover .com-qr-desc {
  display: block;
  line-height: normal;
}
.com-login {
  padding: 11px;
  line-height: 0;
}
.com-login img{
  display: block;
  width: 20px;
  height: 20px;
}
.com-login-desc {
  display: none;
  text-align: center;
  color: #ba882a;
  font-size: 10px;
}
.com-login:hover .com-login-desc {
  display: block;
  line-height: normal;
}
.com-login:hover img{
  display: none;
}
/*顶部*/
.com-qr-1 {
  padding: 11px 5px;
  line-height: 0;
}
.com-qr-1 img{
  display: none;
}
.com-qr-1:hover {
  padding: 11px 5px;
  display: block;
}
.com-qr-1:hover img {
  top: 36px;
  left: 2.5%;
  display: block;
  background-color: #ffffff;
  padding-bottom: 20px;
  /*padding-right: 6px;*/
  position: absolute;
  z-index:10000;
  width: 118px;
  height: 118px;
}
.com-qr-1:hover .com-qr-desc {
  position: absolute;
  display: block;
  left: 4.5%;
  background-color: #ffffff;
  top: 156px;
  z-index:10000;
  line-height: normal;
}
.com-scroller {
  width: 43px;
  height: 43px;
  line-height: 43px;
  font-size: 30px;
  cursor: pointer;
}
.search-icon {
  position: relative;
  float: left;
  top: -33px;
  left: 16px;
  font-size: 18px;
  font-weight: 300;
  color: #787878;
  cursor: pointer;
}
.search-remove {
  position: relative;
  top: -32px;
  float: right;
  right: -13%;
  font-size: 18px;
  font-weight: 300;
  color: #787878;
  cursor: pointer;
}
.fixed-com .com-item.qq-wrp {
  width: 20px;
  height: 20px;
  padding: 11px;
  float: right;
  border: 1px solid #e5e5e5;
  text-align: center;
}
.com-hide {
  display: none;
}
.com-wrp:hover {
  width: 180px;
}
.com-wrp:hover .com-hide {
  display: block;
}
.wechat-icon:hover .com-hide{
  display: block;
}
.fixed-com .com-wrp:hover .com-item.qq-wrp {
  width: auto;
  height: auto;
  text-align: left;
  float: none;
  padding: 15px 0 15px 20px;
}
.fixed-com .com-wrp:hover .icon-fa {
  float: left;
  margin-right: 8px;
  margin-top: 3px;
}
.panel {
  position: absolute;
  z-index: 10000;
  display: block;
  width: 140px;
  height: 130px;
  line-height: 2.2em;
  top: 35px;
  left: 78%;
  padding-top: 8px;
  background-color: #f0f0f0;
  border: 1px solid #e5e5e5;
}
.panel a {
  text-decoration: none;
}
.categ {
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 4px;
}
.categ-div:hover {
  border-bottom:2px solid #ba882a;
}
.categ-line {
  background-color: #ba882a;
  height: 3px;
}
</style>



// WEBPACK FOOTER //
// App.vue?7faa37a0